











import Vue, { PropType } from 'vue';

import { TabOption } from '@/components/GPageHeader.vue';

interface DataType {
  tabLinks: TabOption[];
  headingTexts: object[];
  buttons: object[];
}

// const targetPageName = 'exhibitor-booth-edit';

export default Vue.extend({
  name: 'GBoothEditHeader',
  props: {
    isInvalid: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    onClickPreview: {
      type: Function as PropType<Function>,
    },
    onClickSave: {
      type: Function as PropType<Function>,
    },
    currentPage: {
      type: String as PropType<string>,
      required: true,
    },
    id: {
      type: String as PropType<string>,
      default: null,
    },
    selectedTemplate: {
      type: Number as PropType<number>,
      default: null,
    },
    targetPageName: {
      type: String as PropType<string>,
      default: 'exhibitor-booth-edit',
    },
  },
  computed: {
    showTabLinks(): object[] {
      if (this.selectedTemplate !== 3) {
        return this.tabLinks.filter((tabLink) => tabLink.text !== 'ピックアップ');
      }

      return this.tabLinks;
    },
  },
  data(): DataType {
    return {
      buttons: [{ text: '保存', onClick: this.onClickSave, withValidation: true }],
      headingTexts: [{ text: this.id === 'new' ? 'ブースページ新規登録' : 'ブースページ編集' }],
      tabLinks: [
        {
          value: 0,
          text: '基本設定',
          to: { name: this.targetPageName, query: { page: 'settings', id: this.id } },
          validationId: 'g-booth-setting-form',
        },
        {
          value: 1,
          text: '商品選択',
          to: { name: this.targetPageName, query: { page: 'items', id: this.id } },
          validationId: 'g-booth-item-form',
        },
        {
          value: 2,
          text: 'テンプレート選択',
          to: { name: this.targetPageName, query: { page: 'pageSettings', sub: 'template', id: this.id } },
          validationId: 'g-booth-template-form',
        },
        {
          value: 3,
          text: 'デザイン設定',
          to: { name: this.targetPageName, query: { page: 'pageSettings', sub: 'design', id: this.id } },
          validationId: 'g-booth-design-form',
        },
        {
          value: 4,
          text: 'ピックアップ',
          to: { name: this.targetPageName, query: { page: 'pageSettings', sub: 'pickup', id: this.id } },
          validationId: 'g-booth-pickup-form',
        },
        {
          value: 5,
          text: 'ストーリー',
          to: { name: this.targetPageName, query: { page: 'pageSettings', sub: 'story', id: this.id } },
          validationId: 'g-booth-story-form',
        },
        {
          value: 6,
          text: '商品掲載',
          to: { name: this.targetPageName, query: { page: 'pageSettings', sub: 'lineup', id: this.id } },
          validationId: 'g-booth-lineup-form',
        },
      ],
    };
  },
});
